import { ConfirmationDialogAction, ConfirmationDialogResult } from "@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component";
import { FocusManagedDialogComponent } from "@/core/components/dialogs/focus-managed-dialog.component";
import { FocusService } from "@/core/services/focus.service";
import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { DialogRef } from "@progress/kendo-angular-dialog";

@Component({
    selector: 'url-dialog',
    templateUrl: './url-dialog.component.html',
    styleUrls: ['./url-dialog.component.scss']
})
export class UrlDialogComponent extends FocusManagedDialogComponent {
    public formGroup: FormGroup;

    constructor(protected focusService: FocusService, dialog: DialogRef) { 
        super(focusService, dialog);
    
        const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

        this.formGroup = new FormGroup({
          url: new FormControl('', [Validators.required, Validators.pattern(reg)])
        });
      }
      
  public get isUrlValid(): boolean {
    return this.formGroup.get('url')?.valid ?? false;
  }

    public onCancelClick() {
        let result: UrlDialogResult = new UrlDialogResult();
    
        result.action = ConfirmationDialogAction.Cancel;
    
        this.dialog.close(result);
      }
    
      public onSubmitClick() {
        let result: UrlDialogResult = new UrlDialogResult();
    
        result.action = ConfirmationDialogAction.Confirm;
        result.url = this.formGroup.get('url')?.value ?? "";
    
        this.dialog.close(result);
      }
}

export class UrlDialogResult extends ConfirmationDialogResult {
    public url: string;
}  